"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExploArtifactOptions = exports.ExploPlacement = void 0;
// Recall to update GQL type when updating this
var ExploPlacement;
(function (ExploPlacement) {
    ExploPlacement.CreditFacilityOptions = [
        'lenderFacilitiesTab',
        'borrowerStratsPage',
    ];
    ExploPlacement.OrganizationOptions = [
        'lenderPortfolioTab',
        'limitedPartnersDashboard',
    ];
    ExploPlacement.AllOptions = [
        ...ExploPlacement.CreditFacilityOptions,
        ...ExploPlacement.OrganizationOptions,
    ];
    ExploPlacement.isExploCreditFacilityOptionType = (type) => {
        return ExploPlacement.CreditFacilityOptions.includes(type);
    };
    ExploPlacement.isExploOrganizationOptionType = (type) => {
        return ExploPlacement.OrganizationOptions.includes(type);
    };
})(ExploPlacement || (exports.ExploPlacement = ExploPlacement = {}));
exports.ExploArtifactOptions = ['dashboard', 'reportBuilder'];
//# sourceMappingURL=Explo.js.map